import { Button, TextField, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { FC, useEffect, useState } from "react"
import { ClimbingEventGroup } from "../../../models/ClimbingEvent"
import { DateRangePicker } from "../components/DateRangePicker"

interface Props {
    group: ClimbingEventGroup,
    handleUpdateGroup: (group: ClimbingEventGroup) => void
}

export const EditGroup: FC<Props> = ({ handleUpdateGroup, group }) => {
    const [newGroup, setNewGroup] = useState(group)
    const [error, setError] = useState("")
    useEffect(() => {
        if (newGroup.name.length === 0) {
            setError("Nazwa grupy nie może być pusta")
        } else if (newGroup.startDate > newGroup.endDate) {
            setError("Data końca nie może być wcześniejsza niż data początku")
        } else {
            setError("")
        }
    }, [newGroup])
    return (
        <Box component="form" sx={{ display: "flex", alignItems: "center", flexDirection: "column", }}>
            <TextField label="Nazwa grupy" value={newGroup.name} onChange={(e) => setNewGroup({ ...newGroup, name: e.target.value })} />
            <DateRangePicker
                startDateValue={newGroup.startDate}
                startDateChange={(startDate) => setNewGroup({ ...newGroup, startDate })}
                endDateValue={newGroup.endDate}
                endDateChange={(endDate) => setNewGroup({ ...newGroup, endDate })}
                timePicker={true} />
            <Button disabled={error.length > 0} onClick={() => handleUpdateGroup(newGroup)}>Zapisz</Button>
            <Typography color="error" sx={{ display: "block", mt: 2 }}>{error || ""}</Typography>
        </Box>
    )
}